<template>
    <div class="yh-page">

        <el-tabs v-model="activeName">
          <el-tab-pane name="MemberList">
            <span slot="label">
              <el-badge  style="height: 70px; top: 10px;; position: relative;">
                会员信息
              </el-badge>
            </span>
            <member-list ref="member"></member-list>
          </el-tab-pane>
          <el-tab-pane name="QuitMemberList">
            <span slot="label">
              <el-badge  style="height: 70px; top: 10px;; position: relative;">
                已退会会员
              </el-badge>
            </span>
            <quit-member-list ref="ship"></quit-member-list>
          </el-tab-pane>
        </el-tabs>
    </div>
  </template>
  
  <script>
  import MemberList from './list'
  import QuitMemberList from './quit'
  
  export default {
    components: {
        MemberList,
        QuitMemberList
    },
    data() {
      return {
        activeName: 'MemberList',
      }
    },
    methods: {
    
    },
    mounted() {

    }
  }
  </script>